module.exports = __webpack_public_path__ + "img/move_itmes.887eab62.svg";